import CONST from '../../../../../includes/primitives/_constant_demo'
import * as d3 from 'd3'
export default {
  data: () => ({
    HOST: CONST.HOST_NAME_RESOURCE + '/resources/',
    Boundary: CONST.HOST_NAME_RESOURCE + '/resources//Visualization/SystemBoundary/',

    canvasForm: null,
    canvasManual: null,
    canvasOptions: null,
    canvasSystems: null,

    rawData:    [],
    setData:    [],
    chartData:  [],

    handover :null,
    search :null,
    sundriesConfig :null,

    // Chart
    timeline:  {type: 'month'},
    primary:   {text: 'Y', grid: 'Y', position: 'left',  tSize: 8, tColor: '#757575', unit: '' , },
    secondary: {text: 'Y', grid: 'Y', position: 'right', tSize: 8, tColor: '#757575', unit: '', },

    chart: {
      grid: 5,
      width: 255,
      height: 130,
      barGap: 1,
      itrs:{
        B:   {x: 45,y: 780},
        P07: {x: 45,y: 450},
        I01: {x: 45,y: 800},
      },
      styles: [
        {name: 'Week',       code: 'WK',  type: 'BAR',  act : 'Y', size: 4, color: '#B4E3FA', node: 0, opacity: 1},
        {name: 'Cumulative', code: 'CUM', type: 'LINE', act : 'Y', size: 1, color: '#44A9DF', node: 2, opacity: 1},
      ]
    },

    keys:       null,
    filters:    null,

    items: [
      {name: 'MCC',     code: 'MCC',},
      {name: 'A-ITR',   code: 'A',},
      {name: 'A Punch', code: 'PA',},
      {name: 'B-ITR',   code: 'B',},
      {name: 'B Punch', code: 'PB',},
    ],
    
    summary: [
      {id: 'SUM-SYS',     type: '',    code: 'SYS',     req: '',      filter: ``,},
      {id: 'SUM-DESC',    type: '',    code: 'DESC',    req: '',      filter: ``,},
      {id: 'SUM-MCC-TOT', type: '',    code: 'MCC_TOT', req: 'MCC',   filter: ``,},
      {id: 'SUM-MCC-ACT', type: '',    code: 'MCC_ACT', req: 'MCC',   filter: `[MCC_A] IS NOT NULL`,},
      {id: 'SUM-MCC-REM', type: '',    code: 'MCC_REM', req: 'MCC',   filter: `[MCC_A] IS NULL`,},
      {id: 'SUM-MCC-PRO', type: 'PRO', code: 'MCC_PRO', req: '',      filter: ``,},
      {id: 'SUM-MCC-BAR', type: 'BAR', code: 'MCC_PRO', req: '',      filter: ``,},
      {id: 'SUM-A-TOT',   type: '',    code: 'A_TOT',   req: 'ITR',   filter: `[CAT] = 'A'`,},
      {id: 'SUM-A-ACT',   type: '',    code: 'A_ACT',   req: 'ITR',   filter: `[CAT] = 'A' AND [ACTUAL] IS NOT NULL`,},
      {id: 'SUM-A-REM',   type: '',    code: 'A_REM',   req: 'ITR',   filter: `[CAT] = 'A' AND [ACTUAL] IS NULL`,},
      {id: 'SUM-A-PRO',   type: 'PRO', code: 'A_PRO',   req: '',      filter: ``,},
      {id: 'SUM-A-BAR',   type: 'BAR', code: 'A_PRO',   req: '',      filter: ``,},
      {id: 'SUM-PA-TOT',  type: '',    code: 'PA_TOT',  req: 'PUNCH', filter: `[CAT] = 'A'`,},
      {id: 'SUM-PA-ACT',  type: '',    code: 'PA_ACT',  req: 'PUNCH', filter: `[CAT] = 'A' AND [CLEAR] IS NOT NULL`,},
      {id: 'SUM-PA-REM',  type: '',    code: 'PA_REM',  req: 'PUNCH', filter: `[CAT] = 'A' AND [CLEAR] IS NULL`,},
      {id: 'SUM-PA-PRO',  type: 'PRO', code: 'PA_PRO',  req: '',      filter: ``,},
      {id: 'SUM-PA-BAR',  type: 'BAR', code: 'PA_PRO',  req: '',      filter: ``,},
      {id: 'SUM-B-TOT',   type: '',    code: 'B_TOT',   req: 'ITR',   filter: `[CAT] = 'B'`,},
      {id: 'SUM-B-ACT',   type: '',    code: 'B_ACT',   req: 'ITR',   filter: `[CAT] = 'B' AND [ACTUAL] IS NOT NULL`,},
      {id: 'SUM-B-REM',   type: '',    code: 'B_REM',   req: 'ITR',   filter: `[CAT] = 'B' AND [ACTUAL] IS NULL`,},
      {id: 'SUM-B-PRO',   type: 'PRO', code: 'B_PRO',   req: '',      filter: ``,},
      {id: 'SUM-B-BAR',   type: 'BAR', code: 'B_PRO',   req: '',      filter: ``,},
      {id: 'SUM-PB-TOT',  type: '',    code: 'PB_TOT',  req: 'PUNCH', filter: `[CAT] = 'B'`,},
      {id: 'SUM-PB-ACT',  type: '',    code: 'PB_ACT',  req: 'PUNCH', filter: `[CAT] = 'B' AND [CLEAR] IS NOT NULL`,},
      {id: 'SUM-PB-REM',  type: '',    code: 'PB_REM',  req: 'PUNCH', filter: `[CAT] = 'B' AND [CLEAR] IS NULL`,},
      {id: 'SUM-PB-PRO',  type: 'PRO', code: 'PB_PRO',  req: '',      filter: ``,},
      {id: 'SUM-PB-BAR',  type: 'BAR', code: 'PB_PRO',  req: '',      filter: ``,},
    ],

    dashboard: [
      {id: 'SUM-SYS',     type: '',    code: 'SYS',     req: '',      filter: ``,},
      {id: 'SUM-DESC',    type: '',    code: 'DESC',    req: '',      filter: ``,},
      {id: 'SUM-MCC-TOT', type: '',    code: 'MCC_TOT', req: 'MCC',   filter: ``,},
      {id: 'SUM-MCC-ACT', type: '',    code: 'MCC_ACT', req: 'MCC',   filter: `[MCC_A] IS NOT NULL`,},
      {id: 'SUM-MCC-REM', type: '',    code: 'MCC_REM', req: 'MCC',   filter: `[MCC_A] IS NULL`,},
      {id: 'SUM-MCC-PRO', type: 'PRO', code: 'MCC_PRO', req: '',      filter: ``,},
      {id: 'SUM-MCC-BAR', type: 'BAR', code: 'MCC_PRO', req: '',      filter: ``,},
      {id: 'SUM-A-TOT',   type: '',    code: 'A_TOT',   req: 'ITR',   filter: `[CAT] = 'A'`,},
      {id: 'SUM-A-ACT',   type: '',    code: 'A_ACT',   req: 'ITR',   filter: `[CAT] = 'A' AND [ACTUAL] IS NOT NULL`,},
      {id: 'SUM-A-REM',   type: '',    code: 'A_REM',   req: 'ITR',   filter: `[CAT] = 'A' AND [ACTUAL] IS NULL`,},
      {id: 'SUM-A-PRO',   type: 'PRO', code: 'A_PRO',   req: '',      filter: ``,},
      {id: 'SUM-A-BAR',   type: 'BAR', code: 'A_PRO',   req: '',      filter: ``,},
      {id: 'SUM-PA-TOT',  type: '',    code: 'PA_TOT',  req: 'PUNCH', filter: `[CAT] = 'A'`,},
      {id: 'SUM-PA-ACT',  type: '',    code: 'PA_ACT',  req: 'PUNCH', filter: `[CAT] = 'A' AND [CLEAR] IS NOT NULL`,},
      {id: 'SUM-PA-REM',  type: '',    code: 'PA_REM',  req: 'PUNCH', filter: `[CAT] = 'A' AND [CLEAR] IS NULL`,},
      {id: 'SUM-PA-PRO',  type: 'PRO', code: 'PA_PRO',  req: '',      filter: ``,},
      {id: 'SUM-PA-BAR',  type: 'BAR', code: 'PA_PRO',  req: '',      filter: ``,},
      {id: 'SUM-B-TOT',   type: '',    code: 'B_TOT',   req: 'ITR',   filter: `[CAT] = 'B'`,},
      {id: 'SUM-B-ACT',   type: '',    code: 'B_ACT',   req: 'ITR',   filter: `[CAT] = 'B' AND [ACTUAL] IS NOT NULL`,},
      {id: 'SUM-B-REM',   type: '',    code: 'B_REM',   req: 'ITR',   filter: `[CAT] = 'B' AND [ACTUAL] IS NULL`,},
      {id: 'SUM-B-PRO',   type: 'PRO', code: 'B_PRO',   req: '',      filter: ``,},
      {id: 'SUM-B-BAR',   type: 'BAR', code: 'B_PRO',   req: '',      filter: ``,},
      {id: 'SUM-PB-TOT',  type: '',    code: 'PB_TOT',  req: 'PUNCH', filter: `[CAT] = 'B'`,},
      {id: 'SUM-PB-ACT',  type: '',    code: 'PB_ACT',  req: 'PUNCH', filter: `[CAT] = 'B' AND [CLEAR] IS NOT NULL`,},
      {id: 'SUM-PB-REM',  type: '',    code: 'PB_REM',  req: 'PUNCH', filter: `[CAT] = 'B' AND [CLEAR] IS NULL`,},
      {id: 'SUM-PB-PRO',  type: 'PRO', code: 'PB_PRO',  req: '',      filter: ``,},
      {id: 'SUM-PB-BAR',  type: 'BAR', code: 'PB_PRO',  req: '',      filter: ``,},

      {id: 'BAR-A-PRO',  code: 'A_PRO', req: '', filter: ``,},
      {id: 'BAR-A-TOT',  code: 'A_TOT', req: 'ITR', filter: ``,},
      {id: 'BAR-A-ACT',  code: 'A_ACT', req: 'ITR', filter: `[CAT] = 'A' AND [ACTUAL] IS NOT NULL`,},
      {id: 'BAR-A-REM',  code: 'A_REM', req: 'ITR', filter: `[CAT] = 'A' AND [ACTUAL] IS NULL`,},
    ],

    itrs: [
      {id: 'P01-TOT', type: '',    code: 'P01_TOT', req: 'ITR',   filter: `[CERT_ID] = 'P-01A'`,},
      {id: 'P01-ACT', type: '',    code: 'P01_ACT', req: 'ITR',   filter: `[CERT_ID] = 'P-01A' AND [ACTUAL] IS NOT NULL`,},
      {id: 'P01-REM', type: '',    code: 'P01_REM', req: 'ITR',   filter: `[CERT_ID] = 'P-01A' AND [ACTUAL] IS NULL`,},
      {id: 'P01-PRO', type: 'PRO', code: 'P01_PRO', req: '',      filter: ``,},
      {id: 'P01-BAR', type: 'BAR', code: 'P01_PRO', req: '',      filter: ``,},
      {id: 'P02-TOT', type: '',    code: 'P02_TOT', req: 'ITR',   filter: `[CERT_ID] = 'P-02A'`,},
      {id: 'P02-ACT', type: '',    code: 'P02_ACT', req: 'ITR',   filter: `[CERT_ID] = 'P-02A' AND [ACTUAL] IS NOT NULL`,},
      {id: 'P02-REM', type: '',    code: 'P02_REM', req: 'ITR',   filter: `[CERT_ID] = 'P-02A' AND [ACTUAL] IS NULL`,},
      {id: 'P02-PRO', type: 'PRO', code: 'P02_PRO', req: '',      filter: ``,},
      {id: 'P02-BAR', type: 'BAR', code: 'P02_PRO', req: '',      filter: ``,},
      {id: 'P04-TOT', type: '',    code: 'P04_TOT', req: 'ITR',   filter: `[CERT_ID] = 'P-04A'`,},
      {id: 'P04-ACT', type: '',    code: 'P04_ACT', req: 'ITR',   filter: `[CERT_ID] = 'P-04A' AND [ACTUAL] IS NOT NULL`,},
      {id: 'P04-REM', type: '',    code: 'P04_REM', req: 'ITR',   filter: `[CERT_ID] = 'P-04A' AND [ACTUAL] IS NULL`,},
      {id: 'P04-PRO', type: 'PRO', code: 'P04_PRO', req: '',      filter: ``,},
      {id: 'P04-BAR', type: 'BAR', code: 'P04_PRO', req: '',      filter: ``,},
      {id: 'P07-TOT', type: '',    code: 'P07_TOT', req: 'ITR',   filter: `[CERT_ID] = 'P-07A'`,},
      {id: 'P07-ACT', type: '',    code: 'P07_ACT', req: 'ITR',   filter: `[CERT_ID] = 'P-07A' AND [ACTUAL] IS NOT NULL`,},
      {id: 'P07-REM', type: '',    code: 'P07_REM', req: 'ITR',   filter: `[CERT_ID] = 'P-07A' AND [ACTUAL] IS NULL`,},
      {id: 'P07-PRO', type: 'PRO', code: 'P07_PRO', req: '',      filter: ``,},
      {id: 'P07-BAR', type: 'BAR', code: 'P07_PRO', req: '',      filter: ``,},
      {id: 'P11-TOT', type: '',    code: 'P11_TOT', req: 'ITR',   filter: `[CERT_ID] = 'P-11A'`,},
      {id: 'P11-ACT', type: '',    code: 'P11_ACT', req: 'ITR',   filter: `[CERT_ID] = 'P-11A' AND [ACTUAL] IS NOT NULL`,},
      {id: 'P11-REM', type: '',    code: 'P11_REM', req: 'ITR',   filter: `[CERT_ID] = 'P-11A' AND [ACTUAL] IS NULL`,},
      {id: 'P11-PRO', type: 'PRO', code: 'P11_PRO', req: '',      filter: ``,},
      {id: 'P11-BAR', type: 'BAR', code: 'P11_PRO', req: '',      filter: ``,},

      {id: 'I01-TOT', type: '',    code: 'I01_TOT', req: 'ITR',   filter: `[CERT_ID] = 'I-01B'`,},
      {id: 'I01-ACT', type: '',    code: 'I01_ACT', req: 'ITR',   filter: `[CERT_ID] = 'I-01B' AND [ACTUAL] IS NOT NULL`,},
      {id: 'I01-REM', type: '',    code: 'I01_REM', req: 'ITR',   filter: `[CERT_ID] = 'I-01B' AND [ACTUAL] IS NULL`,},
      {id: 'I01-PRO', type: 'PRO', code: 'I01_PRO', req: '',      filter: ``,},
      {id: 'I01-BAR', type: 'BAR', code: 'I01_PRO', req: '',      filter: ``,},
      {id: 'I10-TOT', type: '',    code: 'I10_TOT', req: 'ITR',   filter: `[CERT_ID] = 'I-10B'`,},
      {id: 'I10-ACT', type: '',    code: 'I10_ACT', req: 'ITR',   filter: `[CERT_ID] = 'I-10B' AND [ACTUAL] IS NOT NULL`,},
      {id: 'I10-REM', type: '',    code: 'I10_REM', req: 'ITR',   filter: `[CERT_ID] = 'I-10B' AND [ACTUAL] IS NULL`,},
      {id: 'I10-PRO', type: 'PRO', code: 'I10_PRO', req: '',      filter: ``,},
      {id: 'I10-BAR', type: 'BAR', code: 'I10_PRO', req: '',      filter: ``,},
    ],

  }),




  computed: {
    ready2draw() {
      return (
        this.DataItems.length > 0 &&
        Object.keys(this.Canvas).length > 0
      )
    },
  },


  methods: {
    set_Gradients() {
    },

    
  }
}